import { InputDateSelector } from '@/common/components/builder/organisms/InputDateSelector';
import { styled } from '@/stitches.config';
import { TFunction } from 'i18next';
import { SubCenterHeading, SubLeftHeading, SubRightHeading } from './VolumeDistribution';
import { IVolumeDistributionAsString } from '../AddCampaignForm.types';
import { StyledExitIcon } from '@/common/components/base-app/organisms/Modal/Modal.styles';
import { Variants } from '@/common/types';
import { IconButton, Input } from '@/common/components';
import { forwardRef } from 'react';

const RootContainer = styled('li', {
  display: 'flex',
  gap: '$4',
  width: '100%',
});

export const StyledIconButton = styled(IconButton, {
  height: '$8',
  width: '$8',
});

interface VolumeDistributionItemProps {
  volumeDistributionItem: IVolumeDistributionAsString;
  index: number;
  t: TFunction;
  onRemoveVolumeDistribution?: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
  error: IVolumeDistributionAsString;
  onChangeVolumeDistributionItem?: (
    event: React.SyntheticEvent<HTMLInputElement> | string,
    key: keyof IVolumeDistributionAsString,
  ) => void;
}

export const VolumeDistributionItem = forwardRef<HTMLInputElement | null, VolumeDistributionItemProps>(
  (
    {
      volumeDistributionItem,
      index,
      t,
      onRemoveVolumeDistribution,
      onChangeVolumeDistributionItem,
      error,
    }: VolumeDistributionItemProps,
    ref,
  ): JSX.Element => {
    return (
      <RootContainer data-testid={`volume-distribution-id-${index}`}>
        <SubLeftHeading>
          <Input
            ref={ref}
            testId={`volume-${index}`}
            name={`volume-${index}`}
            id={`volume-${index}`}
            label={''}
            value={volumeDistributionItem.numberOfEnrollees}
            onChange={(event) => onChangeVolumeDistributionItem?.(event, 'numberOfEnrollees')}
            placeholder={t('add_campaign.volume_distribution.enrollment_placeholder')}
            error={!!error?.numberOfEnrollees}
            errorDescription={error?.numberOfEnrollees ?? undefined}
          />
        </SubLeftHeading>
        <SubCenterHeading>
          <InputDateSelector
            value={
              volumeDistributionItem.distributionDate ? new Date(volumeDistributionItem.distributionDate) : undefined
            }
            onChange={(date) => {
              if (onChangeVolumeDistributionItem) {
                const volumeDistributionDate = date ? date.toISOString() : '';
                onChangeVolumeDistributionItem(volumeDistributionDate, 'distributionDate');
              }
            }}
            title={t('add_campaign.volume_distribution.distribution_title')}
            direction="horizontal"
            placeHolder={t('add_campaign.volume_distribution.distribution_placeholder')}
            inputProps={{
              width: '100%',
              name: `date-${index}`,
              id: `date-${index}`,
              testId: `date-${index}`,
              error: !!error?.distributionDate,
              errorDescription: error?.distributionDate ?? undefined,
            }}
          />
        </SubCenterHeading>
        <SubRightHeading>
          <StyledIconButton
            variant={Variants.SECONDARY}
            aria-label={t('add_campaign.volume_distribution.remove_item')}
            onClick={onRemoveVolumeDistribution}
          >
            <StyledExitIcon />
          </StyledIconButton>
        </SubRightHeading>
      </RootContainer>
    );
  },
);

VolumeDistributionItem.displayName = 'VolumeDistributionItem';
